<template>
  <validation-observer
    ref="observer"
    v-slot="{ passes, invalid }"
    class="form-container"
  >
    <img
      v-if="$attrs.src && !isLoginPage"
      width="225"
      height="37"
      :src="$attrs.src"
      :alt="`${$attrs.title} Logo`"
    />

    <form
      ref="form"
      class="d-flex flex-fill flex-column w-100"
      method="POST"
      @submit.prevent="passes(submit)"
    >
      <h2
        v-if="headerText"
        :class="['text-center', { 'mb-4': !desc }, { 'mt-3': !isLoginPage }]"
        style="font-weight: 700"
      >
        {{ headerText }}
      </h2>
      <h5
        v-if="desc"
        class="color-dusk mt-1 mb-3 font-weight-normal text-center"
        v-html="desc"
      ></h5>

      <slot />
      <div
        v-if="type === 'forgotPassword'"
        class="mt-3 d-flex flex-column justify-content-center align-items-center gap-1 redirect-area"
      >
        <b-button
          type="submit"
          id="loginSubmit"
          name="loginSubmit"
          class="btn hover lg text-uppercase bg-purple text-white w-100 justify-content-center border-radius-50"
          :disabled="invalid || !isValid"
          :class="{'icon-loader' : isLoading }"
        >
          <span> {{ resource["hrvenue.createCandidateSend"] }} </span>
        </b-button>
        <router-link
          v-if="$attrs.href && type === 'forgotPassword'"
          :to="$attrs.href"
          class="justify-content-center font-weight-bold w-100 return-home-link"
        >
          {{resource["forgotPassword.BackToHomePageText"]}}
        </router-link>
      </div>
      <b-button
        v-if="type !== 'forgotPassword'"
        type="submit"
        id="loginSubmit"
        name="loginSubmit"
        class="btn hover lg text-uppercase bg-purple text-white w-100 justify-content-center border-radius-50"
        :disabled="invalid || !isValid"
        :class="{'icon-loader' : isLoading }"
      >
        <span> {{ resource["hrvenue.createCandidateSend"] }} </span>
      </b-button>
      <template v-if="type === 'login'">
        <span :class="['color-dusk mt-1 mb-1 text-center pt-3']">
          <h5 class="m-0">Aradığınız yeteneklere hızlıca ulaşmak için</h5>
        </span>
      </template>
    </form>
    <router-link
    v-if="type === 'login'"
    class="justify-content-center font-weight-bold w-100 signup-link"
    to="/isveren/ucretsiz-is-ilani"
    target="_blank"
    >  {{resource["forgotPassword.SignUpNowText"]}}</router-link>
  </validation-observer>
</template>

<script>
export default {
  name: 'FormWrapper',

  components: {
    // Loader: () => import('@/components/common/Loader'),
  },
  props: {
    isLoginPage: {
      required: false,
      type: Boolean,
      default: false,
    },
    desc: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: 'Gönder',
    },
    headerText: {
      type: String,
      default: '',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
    enableButton: {
      type: Boolean,
      default: false,
    },
    isValid: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      publicUrl: process.env.PUBLIC_URL,
    };
  },

  computed: {
    csrfToken() {
      // return this.$store.state.account.csrfToken;
      return '';
    },
  },

  mounted() {
    // this.$store.dispatch('account/GET_CSRF_TOKEN');
  },

  methods: {
    async submit() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) this.$emit('submit', this.csrfToken);
    },
    redirectToHome() {
      this.$router.push('/isveren');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/style/design-kit/_variable.scss";
@import "~@/style/starter.scss";

.redirect-area {
  @include media-breakpoint-down(sm) {
    position: relative;
    top: calc(100vh - 360px);
  }
}
.form-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.signup-link,
.return-home-link {
  color: $purple;
  font-size: 14px !important;
  text-align: center;
  &:hover {
    text-decoration: underline;
  }
}
.return-home-link {
  margin-top: 10px;
}
</style>
